/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type KartePlannerCommentUnavailableReason =
  /** 同カルテにカルテコメントを送信済みのためアプローチできない */
  | 'ALREADY_COMMENTED'
  /** すでにマッチしているユーザーのためアプローチできない */
  | 'ALREADY_MATCHED'
  /** プラン開始前(契約期間前)のためアプローチできない */
  | 'BEFORE_CONTRACT_PERIOD'
  /** プランナーがカルテに対応するチャネルを持っていないためアプローチできない */
  | 'CHANNEL_DOES_NOT_MATCH'
  /** 管理者専用無料プランのためコメントできない */
  | 'HAS_MANAGE_ONLY_FREE_PLAN'
  /** PRプランのため、アプローチできない */
  | 'HAS_PR_PLAN'
  /** プランナーの月ごとの送信数上限に達したためアプローチできない */
  | 'REACHED_TO_MONTHLY_LIMIT'
  /** 上記の理由以外においてエラー */
  | 'UNKNOWN';

export type Plan =
  /** V2021_1 エンタープライズプラン */
  | 'V2021_1Enterprise'
  /** V2021_1 プレミアムプラン */
  | 'V2021_1Premium'
  /** V2021_1 スタンダードプラン */
  | 'V2021_1Standard'
  /** V2022_1 Enterpriseプラン */
  | 'V2022_1Enterprise'
  /** V2022_1 Entryプラン */
  | 'V2022_1Entry'
  /** V2022_1 PRプラン */
  | 'V2022_1PR'
  /** V2022_1 Proプラン */
  | 'V2022_1Pro'
  /** V2022_2 管理者専用無料プラン */
  | 'V2022_2ManageOnlyFree'
  /** V2023_1 エンタープライズプラン */
  | 'V2023_1Enterprise'
  /** V2023_1 エキスパートプラン */
  | 'V2023_1Expert'
  /** V2023_1 管理者専用無料プラン */
  | 'V2023_1ManageOnlyFree'
  /** V2023_1 マスタープラン */
  | 'V2023_1Master'
  /** V2023_1 スキルフォースプラン */
  | 'V2023_1SkillForce';

export type KartePlannerCommentFormAvailabilityFragment = { availability: boolean, unavailableReason: Types.KartePlannerCommentUnavailableReason | null };

export type KartePlannerCommentFormViewerFragment = { plan: Types.Plan };

export const KartePlannerCommentFormAvailabilityFragmentDoc = gql`
    fragment KartePlannerCommentFormAvailability on KartePlannerCommentAvailability {
  availability
  unavailableReason
}
    `;
export const KartePlannerCommentFormViewerFragmentDoc = gql`
    fragment KartePlannerCommentFormViewer on Viewer {
  plan
}
    `;